import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { db } from '@/services/index.ts'

export function AdminOverview() {
  const { t } = useTranslation()
  const [usersCount, setUsersCount] = useState<number | null>(null)
  const [vaultsCount, setVaultsCount] = useState<number | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    async function load() {
      const [usersRes, vaultsRes] = await Promise.all([
        db.count('profiles'),
        db.count('vault_metadata'),
      ])
      if (cancelled) return
      if (usersRes.error) setError(usersRes.error.message)
      else setUsersCount(usersRes.data ?? 0)
      if (vaultsRes.error) setError(vaultsRes.error.message)
      else setVaultsCount(vaultsRes.data ?? 0)
    }
    load()
    return () => {
      cancelled = true
    }
  }, [])

  if (error) {
    return (
      <div className="text-error p-4">
        {t('admin.overviewError')}: {error}
      </div>
    )
  }

  return (
    <div className="grid grid-cols-[repeat(auto-fill,minmax(200px,1fr))] gap-6">
      <div className="border-line bg-surface-raised flex flex-col gap-2 rounded-lg border p-8">
        <span className="text-fg-secondary text-sm">
          {t('admin.overviewUsers')}
        </span>
        <span className="text-fg text-2xl font-bold">
          {usersCount === null ? t('common.loading') : usersCount}
        </span>
      </div>
      <div className="border-line bg-surface-raised flex flex-col gap-2 rounded-lg border p-8">
        <span className="text-fg-secondary text-sm">
          {t('admin.overviewVaults')}
        </span>
        <span className="text-fg text-2xl font-bold">
          {vaultsCount === null ? t('common.loading') : vaultsCount}
        </span>
      </div>
    </div>
  )
}
